var exports = {
  "wE": "ReportFlowModal.module__directionScope___RUJKVm",
  "VA": "ReportFlowModal.module__subtitle___RUJKVm",
  "Qs": "ReportFlowModal.module__content___RUJKVm",
  "rf": "ReportFlowModal.module__body___RUJKVm",
  "Lq": "ReportFlowModal.module__loading___RUJKVm",
  "Hj": "ReportFlowModal.module__loadError___RUJKVm",
  "eU": "ReportFlowModal.module__accountNotice___RUJKVm",
  "Es": "ReportFlowModal.module__accountNoticeTitle___RUJKVm",
  "jU": "ReportFlowModal.module__accountNoticeText___RUJKVm",
  "Dc": "ReportFlowModal.module__accountNoticeActions___RUJKVm",
  "fB": "ReportFlowModal.module__submitNote___RUJKVm",
  "QL": "ReportFlowModal.module__splitFooter___RUJKVm",
};

module.exports = exports;
